<template>
	<div class="templatebody" :style="note">
		<div>
			<heard></heard>
		</div>

		<div class="content-margin">
			<div class="query-margin">
				<div class="text-orange">
					<p>查询成功</p>
					<p>{{trackInfo.success_order}}</p>
				</div>
				<div>
					<p>已订舱</p>
					<p>{{trackInfo.state_dc_order}}</p>
				</div>
				<div>
					<p>已发出</p>
					<p>{{trackInfo.state_fc_order}}</p>
				</div>
				<div>
					<p>已收货</p>
					<p>{{trackInfo.state_sh_order}}</p>
				</div>
				<div>
					<p>已安检</p>
					<p>{{trackInfo.state_aj_order}}</p>
				</div>
				<div>
					<p>已入库</p>
					<p>{{trackInfo.state_rk_order}}</p>
				</div>
				<div>
					<p>已组板</p>
					<p>{{trackInfo.state_zb_order}}</p>
				</div>
				<div>
					<p>已起飞</p>
					<p>{{trackInfo.state_qf_order}}</p>
				</div>
				<div>
					<p>已落地</p>
					<p>{{trackInfo.state_ld_order}}</p>
				</div>
				<div>
					<p>已提货</p>
					<p>{{trackInfo.state_th_order}}</p>
				</div>
				<div>
					<p>已完成</p>
					<p>{{trackInfo.state_qs_order}}</p>
				</div>
				<div>
				</div>
			</div>
			<div class="back-color-white query-content-padding">

				<div class="query-results">
					<div class="leftp text-red" >

<!-- 					<el-dropdown trigger="click">
					  <div class="flex-all-center"><p style="margin: 0%0%2%0%;font-size: 23px;">查询失败&nbsp;&nbsp;</p><p style="line-height: 40px;">展开</p></div> 
					  <el-dropdown-menu >
					    <el-dropdown-item v-for="v in trackInfo.fail_order">
					     	<p >{{v.seq}}.&nbsp;{{v.fail_no}}&nbsp;&nbsp;</p>
					    </el-dropdown-item>
							<el-dropdown-item >
							 <p style="color: #000000;"> 以上单号未查询到！</p>
							</el-dropdown-item>
					  </el-dropdown-menu>
					</el-dropdown> -->


						<p style="margin: 0% 0% 1% 0%;font-size: 0.11979166666666667rem;" v-if="trackInfo.fail_order.length>0">查询失败：</p>
						<div class="search " style="font-size: 0.09375rem ;" v-if="trackInfo.fail_order.length>0">
							<div class="flex1">
								<p v-for="(v,index) in trackInfo.fail_order" :key="index" class="nosearch">{{v.seq}}.&nbsp;{{v.fail_no}}&nbsp;&nbsp;</p>
								<p style="color: #000000;white-space: nowrap;font-size:0.07291666666666667rem ;line-height:0.11979166666666667rem " > 以上单号系统未查询到！</p>
							</div>
							
							
						</div>

						<!-- <div style="position:absolute;background-color: #FFFFFF;padding: 1%;margin-left: 1%;">
							<label class="drop" for="_1">查询失败：</label>
							<input id="_1" type="checkbox"> 
							<div><p v-for="v in trackInfo.fail_order">{{v.seq}}.&nbsp;{{v.fail_no}}&nbsp;&nbsp;</p>
							<p style="color: #000000;"> 以上单号未查询到！</p></div>
						</div> -->


					</div>
					<div class="leftp text-red" v-if="trackInfo.fail_order.length<0">
						<p style="margin: 0%0%2%0%;font-size: 23px;">&nbsp;</p>
						<div class="flex-alcenter query-linhe" style="font-size: 18px;">
						</div>
					</div>

					<div class="gpssearch">
						<el-popover placement="bottom-end" trigger="click" v-model="pops" width="400"
							style="padding: 0px;" @show = 'show'>
							<el-button class="   btn "  slot="reference"> 运 单 查 询 <i
									class="el-icon-search el-icon--right"></i>
							</el-button>
							<div class="flex-all-center  width-100">
								<div class="back-color-white  width-100">
									<div class="back-color-db query-title-text-mar">
										<el-row>
											<el-col :span="20">
												<p class="text-white">运单轨迹一键查询，掌握精准时间节点</p>
											</el-col>
											<el-col :span="4">
												<el-button type="info" @click="pop()" size="mini" icon="el-icon-close">
												</el-button>
											</el-col>
										</el-row>
									</div>
									<div class="query-title-margin">
										<div class="edit" id="appst">
											<div id="leftBox"><textarea wrap="off" cols="2" id="leftNum" ref="leftNum"
													disabled></textarea></div>
											<textarea @input="handleTextareaInput" v-model="textarea2"
												placeholder="请输入您的运单号,并以换行进行分隔"
												onscroll="document.getElementById('leftNum').scrollTop = this.scrollTop;"
												id="edit-content"></textarea>
										</div>
										<div class="margin-top-l searchbt">
											<el-button class="text-white btt "    @click="querys()">
												运 单 查 询 <i class="el-icon-search el-icon--right"></i>
											</el-button>
										</div>
									</div>
								</div>
							</div>
						</el-popover>
					</div>
				</div>



				<div>
					<ul :class="trackInfo.fail_order.length<=0? 'query-list':'query-list2'">
						<li v-for="(v,index) in  trackInfo.query_list" :key="index" class="infinite-list-item tap" @click="map(v.order_no)">
							<div class="query-table">
								<div class="leftp flex-alcenter">
									<div>
										<div class="flex-alcenter ">
											<p class="query-list-order">{{v.order_no}}</p>
											<el-tag effect="dark"> {{v.state}}</el-tag>
										</div>
										<div class="flex" style="margin-top:10px">
											<p class="query-list-p">{{v.depart_port}}-</p>
											<p class="query-list-p">{{v.arrive_port}}</p>
										</div>
									</div>
								</div>
								<div class="flex-text-center">
									<span style="color: #adadad;">了解详情 >></span>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>


          <div class="thing"></div>

		<div class="buttom-text">
			<p>版权所有：海南云航翊信息科技有限责任公司 Copyright © 2014.Company name All rights reserved.</p>
		</div>
	</div>
</template>
<script>
	import "@/assets/css/home.css"
	import "@/assets/css/public.css"
	import heard from './public/heard.vue'
	export default {
		components: {
			heard
		},
		data() {
			return {
			
				el: 'appst',
				num: '',
				textarea2: '',
				pops: false, // 弹出信息关闭
				visible: false,
				note: {
					backgroundImage: "url(" + require("./../assets/img/bg-plane.png") + ")",
					backgroundRepeat: "no-repeat",
					backgroundSize: "100% 100%",
				},
				trackInfo: {},
			}
		},
		beforeCreate() {},
		created() {
			this.query()
		},
		mounted() {
			this.handleTextareaInput({
				target: {
					value: this.textarea2
				}
			})
	
		},
		methods: {

			get_track_list(track_list) {
				console.log(1)
				var _this = this;
				let arr = _this.zhuan(track_list)
				
				_this.$source.post('/v1/flight_order/track', {
						order_no: arr
					}, )
					.then((res) => {
						if (res.data.code == 30201 || res.data.code == 30202) {
							this.$message({
								message: '查询失败,请检查输入内容',
								type: 'warning'
							});
						} else if (res.data.code == 30203) {
							this.$message({
								message: '查询失败,请联系开发人员',
								type: 'warning'
							});
						} else if (res.data.code == 30200) {
						   console.log(res,1122)
							_this.trackInfo = res.data.data || {};
							this.pop()
						}
					}, (err) => {});
			},
			querys() {
				if (this.textarea2 !== undefined && this.textarea2 !== '') {

					this.get_track_list(this.textarea2);
					localStorage.setItem('oderNumber',this.textarea2)
				} else {
					this.$message({
						message: '请输入正确单号后查询',
						type: 'warning'
					});
					this.trackInfo = {}
				}
			},
			query() {
				var order_no = this.$route.params.input1
				if (order_no !== undefined && order_no !== '') {
					this.get_track_list(order_no);
				} else {
					
				    this.get_track_list(localStorage.getItem('oderNumber'));
				}
			},
			zhuan: function(input_text) {
				let arr1 = [];
				input_text.split('\n').forEach(function(value, index, array) {
					if (value.replace(/\s+|&nbsp;/ig, '').length > 0) {
						arr1.push(`${value.replace(/\s+|&nbsp;/ig, '')}`)
					}
				});
				return arr1;
			},
			// 控制再次点击查询
			pop() {
				this.textarea2 = '',
					this.pops = false
			},

			map(order_no) {
				
				


				let routeUrl = this.$router.resolve({
					path: '/public/map',
					query: {
						order_no: order_no
					},
				});
				window.open(routeUrl.href, '_blank');

			},
			// 添加序号
			handleTextareaInput(e) {
				this.num = ''
				var str = e.target.value

				str = str.replace(/\r/g, "");
				str = str.split("\n");
				let n = str.length;
				for (var i = 1; i <= n; i++) {
					if (document.all) {
						this.num += i + "\r\n"; //判断浏览器是否是IE  
					} else {
						this.num += i + "\n";
					}
				}
				this.$refs.leftNum.value = this.num
				this.num = '';
			},
			show(){
				this.$refs.leftNum.value =''
               
			}
		}
	}
</script>
<style scoped>
	.el-button--primary {
		background-color: #FD9405;
		border-color: #FD9405;
		font-size: 20px;
	}

	.el-button--primary:hover {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-button--primary:focus {
		background-color: #FD9405;
		border-color: #FD9405;
	}

	.el-button--info {
		background-color: #407087;
		border-color: #407087;
	}

	.el-button--info:hover {
		background-color: #407087;
		border-color: #407087;
	}

	.el-button--info:focus {
		background-color: #407087;
		border-color: #407087;
	}

	.el-tag {
	
		font-size: 18px;
		padding: 0%4%;
		height: 22px;
		line-height: 22px;
		margin-left: 15px;
	}

	.el-tag--dark {
		background-color: #3F6F86;
		border-color: #3F6F86;
		color: #fff;
	}

	i {
		font-size: 0.08333333333333333rem ;
		color: #FFFFFF;
		margin-left: 0.10416666666666667rem ;
	}
	.query-list-order{
		white-space: nowrap;
	}
	.bt{
		width: 2.0833333333333335rem ;
	}
	.nosearch{
		
		
		flex-wrap: wrap;
		white-space: nowrap;
	}
	.search{
		width: 7.552083333333333rem ;
		
		display: flex;
	}
	.flex1{
		width: 7.1875rem;
		display: flex;
		flex-wrap: wrap;
	}
	.gpssearch{
		position: absolute;
		right: 1.4583333333333333rem ;
	}
	.btn{
		background: #FD9405;
		color: #fff;
		border: none;
		
	}
	.query-title-text-mar p{
		font-size: 0.08333333333333333rem ;
	}
	.btt{
		background: #FD9405;
		border: none;
	}
	.tap:hover{
		cursor: pointer;
	}
	.searchbt{
		margin-left: 0.18229166666666666rem ;
	}
	.thing{
		width: 100%;
		height: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/components/queryok.vue